<script setup>
import {ref, computed} from 'vue';
import moment from "moment";
import axios from "axios";

const props = defineProps({
    selectedFeatures: {
        type: Array,
        required: true
    },
    users: {
        type: Object,
        required: true
    },
    permissions: {
        type: Object,
        required: true
    },
    showBulkComplete: {
        type: Boolean,
        required: true
    },
    bulkUpdated: {
        type: Function,
        required: true
    }
})

const emit = defineEmits(['update:showBulkComplete']);

const step = ref(1)
const user = ref(null)
const loading = ref(false)
const dateCompleted = ref(moment().format("YYYY-MM-DD"))
const notes = ref(null)

const closeModal = () => {
    emit('update:showBulkComplete', false);
}
const completeWork = () => {
    if (!user.value) {
        alert('Completed By selection is required.');
        return;
    }

    loading.value = true;

    axios.post('/api/works/bulk/complete', {
        'user': user.value.id,
        'selectedFeatures': props.selectedFeatures,
        'dateCompleted': dateCompleted.value,
        'notes': notes.value,
    })
        .then((response) => {
            loading.value = false;
            props.bulkUpdated();
            closeModal();
        })
        .catch((error) => {
            alert('Error: ' + error);
            props.showBulkComplete = false;
        });

}


</script>


<template>
    <div
        style="max-height:95%"
        class="fixed top-0 inset-x-0 px-4 py-4 sm:inset-0 sm:flex sm:items-center sm:justify-center z-10"
    >
        <div class="fixed inset-0 transition-opacity" style="z-index:-1">
            <div class="absolute inset-0 bg-slate-500 opacity-75"></div>
        </div>

        <div
            class="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all  sm:max-w-xl sm:w-full lg:w-1/2 z-10 overflow-y-auto"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
        >
            <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div class="w-full">
                    <div
                        v-if="step === 1"
                        class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left"
                    >
                        <h3
                            class="text-lg leading-6 font-medium text-slate-900"
                            id="modal-headline"
                        >
                            Bulk Complete the Selected Works
                        </h3>

                        <div class="pt-6 w-full">

                            <div class="flex flex-col">
                                <label for="user" class="block text-sm font-medium text-slate-700">Completed Date</label>
                                <input
                                    id="bulkPlantedDate"
                                    name="bulkPlantedDate"
                                    type="date"
                                    v-model="dateCompleted"
                                    class="appearance-none bg-slate-100 text-slate-700 block w-1/2 px-3 py-2 rounded-lg shadow-sm placeholder-slate-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                />
                            </div>

                        </div>
                        <div
                            class="w-full flex md:flex-no-wrap flex-wrap justify-center text-center py-4"
                        >
                        </div>
                        <div class="w-full">

                            <div class="flex flex-col">
                                <label for="user" class="block text-sm font-medium text-slate-700">Completed By</label>
                                <v-select
                                    v-model="user"
                                    :options="users.active_users"
                                    label="name"
                                    class="style-chooser"
                                    :rules="[
                      value => !!value || 'User is required',
                    ]"/>
                            </div>

                        </div>
                        <div
                            class="w-full flex md:flex-no-wrap flex-wrap justify-center text-center py-4"
                        >
                        </div>
                        <div class="w-full">

                            <div class="flex flex-col">
                                <label for="user" class="block text-sm font-medium text-slate-700">Completed
                                    Notes</label>
                                <textarea
                                    v-model="notes"
                                    class="rounded-lg appearance-none block w-full bg-slate-100 text-slate-700 border border-slate-200 rounded-sm py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-slate-500"
                                    rows="3"
                                    placeholder="Enter notes here..."></textarea>
                            </div>

                        </div>
                        <div
                            class="w-full flex md:flex-no-wrap flex-wrap justify-center text-center py-4"
                        >
                        </div>

                    </div>

                </div>
            </div>
            <div
                class="bg-slate-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse"
            >
                <span
                    class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto"
                >
                    <button
                        @click="
                            closeModal();
                        "
                        type="button"
                        class="mr-2 inline-flex justify-center w-full rounded-lg border border-slate-300 px-4 py-2 bg-slate-100 text-base leading-6 font-semibold text-slate-700 shadow-sm hover:text-slate-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                    >
                        Cancel
                    </button>
                    <button
                        v-if="!loading"
                        @click="completeWork();"
                        type="button"
                        class="whitespace-nowrap inline-flex justify-center w-full rounded-lg border border-transparent px-4 py-2 bg-blue-600 text-base leading-6 font-semibold text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:border-red-700 focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                    >
                        Complete Work
                    </button>
                    <button
                        v-else
                        disabled
                        type="button"
                        class="whitespace-nowrap inline-flex justify-center w-full rounded-lg border border-transparent px-4 py-2 bg-blue-600 text-base leading-6 font-semibold text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:border-red-700 focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                    >
                        Completing...
                    </button>
                </span>
            </div>
        </div>
    </div>
</template>

